import { Redirect } from 'expo-router';
import React from 'react';

export default function ApplePayWeb() {
  return <Redirect href="/" />;
}
